import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { getMessage } from '@/helpers/utils';
import { Snackbar } from '@scramble/ui';
import { cashService } from '../../services/cashService';

export const useCreateWithdrawRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      cashService
        .createWithdrawRequest(payload)
        .then(response => {
          const { status, data } = response;
          const message = getMessage(data);

          if (status === 200) {
            queryClient.setQueryData([QUERY_KEYS.cash.withdraw_info], prev => ({
              ...prev,
              cash: data.cash,
            }));
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.cash.withdraw_history],
            });
            Snackbar({ type: 'success', text: message});
            return { data, success: true };
          }

          if (status === 400) {
            Snackbar({ type: 'danger', text: message });
          }

          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, message: e.message };
        }),
  });
};
